<template>
  <div>
    <div class='sidepanel__slider container-fluid'>
      <slider animation="fade"
              :auto='false'
              :indicators='false'
              :control-btn='false'
              :current-index='tutorialstep'>
        <slider-item v-for="(step, index) in tutorial.steps" :key="index">
            <div class='tutorial-content d-flex flex-column'>
              <h2>{{ step.title }}</h2>
              <div class='tutorial-content__paras'>
                <p v-for="c in P(step.content)" v-html="c"></p>
                <div v-if="index == 3" v-html="yourchromosomes"></div>
              </div>
              <button class='mt-auto' @click="reset()">{{ tutorial.buttons.startover.text }}</button>
            </div>
        </slider-item>
      </slider>
    </div>
  </div>
</template>

<script>

import { Slider, SliderItem } from 'vue-easy-slider'
  
export default { 
    name: 'sidepanel',
    props: [ 'tutorial', 'tutorialstep', 'yourchromosomes' ],
    data: function () {
      return {
      }
    },
    methods: {
      P: function(s) {
        return s.split("\n")
      },
      startover: function() {
        this.$emit('startover');
      },
      reset: function() {
        this.$emit('reset');
      },
    },
    components: {
      Slider,
      SliderItem
    }
  }

</script>

<style lang="scss">

  @import '../stylesheets/_zeplin';

  .sidepanel {
    height: 100%;
    width: 100%;
    background: $brand-03;

    &__slider,
    .slider,
    .slider-item,
    .tutorial-content {
      height: 100% !important;
      width: 100%;
    }

    .slider-item .wrap {
      transform: none !important;
    }

    .tutorial-content {

      padding: 0 3rem 0 4.5rem;

      h2 {
        @include title-xx-large;
        margin-top: 18rem;
        margin-bottom: 2rem;
      }
      p {
        font-size: 1.7rem;
      }
      span {
        display: inline-block;
        background: $ui-02;
        width: 1em;
        height: 1em;
        border-radius: 100%;
        color:black;
        text-align: center;
        line-height: 1;
      }
      button {
        margin: 5rem 0 8rem;
      }

      .chromosomes {
        transform-origin: top center;
        transform: scale(0.6);
        margin-bottom: -20rem;
        span {
          background: transparent;
        }
      }

      .tutorial-content__paras{
        display: flex;
        flex-direction: column;
      }
      .tutorial-content__paras > p:nth-child(1) {
        order: 1;
      }
      .tutorial-content__paras > div {
        order: 2;
      }
      .tutorial-content__paras > p {
        order: 3;
      }

    }
  }


</style>




// WEBPACK FOOTER //
// src/assets/components/sidepanel.vue